import axios from 'axios'

async function delete_tst(data,add_test,add_tests,tests,dispatch,setDeleting,setMessage,setOpen,navigate){
    try{

    setDeleting(true)
    const deleteTest = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}delete-test/`,data,{
           headers:{
                  "Content-Type":"application/json",
                  "Authorization":`Bear ${data?.token}`
              }
       }).catch(err=>{console.log(err)})

        if (deleteTest?.status == 200 && deleteTest?.data.success == true) {

            const filterData = tests.filter((item)=>item.id !== data?.id)

            const newTests = [...filterData]

            await dispatch(add_tests(newTests))
            await dispatch(add_test(newTests[0]))

            localStorage.setItem("iTest_test",JSON.stringify({
                id:newTests[0]?.id,
                name:newTests[0]?.name,
                description:newTests[0]?.description,
                time:newTests[0]?.time,
                start_moment:newTests[0]?.start_moment,
                start_date:newTests[0]?.start_date,
                questions:newTests[0]?.questions,
                language:newTests[0]?.language,
                describe:newTests[0]?.describe,
                specialty:newTests[0]?.specialty,
                field:newTests[0]?.field,
                level:newTests[0]?.level
            }))
            setMessage("Assessment deleted")
            setOpen(true)
            setDeleting(false)
            navigate("/dashboard")
            
        }else{
            setMessage(deleteTest?.data?.message)
            setOpen(true)
            setDeleting(false)
        }
    }catch(err){
        console.log(err)
        setDeleting(false)
    }
}

export default delete_tst